module.exports = __webpack_public_path__ + "img/circle-x.674c0769.svg";